/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Crm_Send_InvalidInputs */

const en_error_crm_send_invalid = /** @type {(inputs: Error_Crm_Send_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The send cannot go out like this: check its template, its audience and its links.`)
};

/**
* | output |
* | --- |
* | "The send cannot go out like this: check its template, its audience and its links." |
*
* @param {Error_Crm_Send_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_crm_send_invalid = /** @type {((inputs?: Error_Crm_Send_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Crm_Send_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_crm_send_invalid(inputs)
});